import React, { useRef } from "react";
import { FormControl, Card, Layout, Button, usePath, useAppConfig } from "@fdoh/health-ui-react";
import { useHistory, Link } from "react-router-dom";
import { useSubmitForm } from "../../hooks/useSubmitForm";
import { Controller, useForm } from "react-hook-form";
import { AdditionalInformationFormInput, schema, AdditionalInformationFormProps, ComplianceData,ContractorData,ContractorDto } from "./AdditionalInformation.types";
import { useData } from "../../hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import CSS from 'csstype';
import { Constants, InspectionStatus } from "../../helpers/Constants";
import { Select2 } from '../../components/Select2';
import { SelectOption } from "../../types";
import { toast } from "react-toastify";
import { InspectionStatusInput } from "../InspectionHome/InspectionHome.types";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";

export const AdditionalInformationForm = (props: AdditionalInformationFormProps) => {
    const history = useHistory();
    const path = usePath();
    const complianceData = useData<ComplianceData[]>("Compliance") || [];
    const contractorData = useData<ContractorData[]>(`Contractor/GetContractorsByApplicationid/${props.applicationId}`) || [];
    const config =  useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
         const user =  useProfile(application) as UserSecurityInput;

    //const contractorData = useData<ContractorDto[]>(`Contractor/GetContractorsByCounty/${applicationData.countyId}`) || [];
    const inspectionStatusData = useData<InspectionStatusInput>("inspectionDetails/" + props.applicationInspectionId);
    const { control, handleSubmit, setValue, watch } = useForm<AdditionalInformationFormInput>({
         resolver: yupResolver(schema),
        defaultValues: props.values as any,
    });
    const formRef = useRef<HTMLFormElement>(null);

    function timeout(delay: number) {
        return new Promise(res => setTimeout(res, delay));
    }

   


    const onSubmit = useSubmitForm<AdditionalInformationFormInput>(
        'AdditionalInformation',
        async (response) => {
            toast.success("Additional Information Saved Successfully");
            await timeout(2000);
            let inspectionStatus = watch("inspectionStatusId");
            if(inspectionStatus == InspectionStatus.Complete){
                if(inspectionStatusData?.abandonmentInspectionId == null 
                    || inspectionStatusData?.abandonmentInspectionId == undefined){
                        history.push({
                            pathname: "/abandonment/",
                            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                        })
                    }
                    else {
                        history.push({
                            pathname: "/abandonment/"+ inspectionStatusData?.abandonmentId,
                            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                        })
                    }
            }
            else if (inspectionStatus == InspectionStatus.Incomplete){
                history.push(`/inspectionDetails/${inspectionStatusData?.applicationInspectionId}`) ;
            }
            
        },
        props.action
    );



    const submit = () => {
        setValue('applicationId', props.applicationId ? props.applicationId : 0);
        setValue('applicationInspectionId', props.applicationInspectionId ? props.applicationInspectionId : 0);
        if(ehdContactID != null)
        {
            setValue('ehdcontactName',contractorData.find(x => Number(x.id) == ehdContactID)?.name);
        }
        if(inspectionStatusData?.additionalInformationInspectionId == null 
            || inspectionStatusData?.additionalInformationInspectionId == undefined){
                setValue('dateCreated', new Date());
                setValue('createdBy', user?.userName);
            }
            else {
                setValue('dateUpdated', new Date());
                setValue('updatedBy', user?.userName);
            }
        if (formRef.current) {

            formRef.current.dispatchEvent(
                new Event('submit', { cancelable: true, bubbles: true })
            );

        }
    }


   
    const h1Styles: CSS.Properties = {
        float: "right",
       marginTop: '27px'
      };
    const Ctitle: CSS.Properties = {
        fontSize: "32px",
        marginTop: "20px",
        marginBottom: "0px",
        color: "#134076",
    }
    const controlInline: CSS.Properties ={
        display: "flex",
        whiteSpace: "nowrap"
    }
 
    
    let showUnobstructedAreaComment = watch("unobstructedAreaComplianceId");
    let showStormwaterRunoffComment = watch("stormwaterRunoffComplianceId");
    let showAlarmComment = watch("alarmComplianceId");
    let showSupportDocumentComment = watch("supportDocumentComplianceId");
    let showBuildingAreaComment = watch("buildingAreaComplianceId");
    let showSitePlanComment = watch("sitePlanComplianceId");
    let showFinalSiteGradeComment = watch("finalSiteGradeComplianceId");
    let showContractorComment = watch("contractorComplianceId"); 

    let ehdContactID = watch("ehdcontactId");

    let markAllCompliance = watch("markAll");

    const markClick = (e: any) => {
          
            setValue('unobstructedAreaComplianceId', markAllCompliance);
            setValue('stormwaterRunoffComplianceId', markAllCompliance);
            setValue('alarmComplianceId', markAllCompliance);
            setValue('supportDocumentComplianceId', markAllCompliance);
            setValue('buildingAreaComplianceId', markAllCompliance);
            setValue('sitePlanComplianceId', markAllCompliance);
            setValue('finalSiteGradeComplianceId', markAllCompliance);
            setValue('contractorComplianceId', markAllCompliance);        

            e.preventDefault();
        };


        return (
            <form ref={formRef} onSubmit={handleSubmit((data: AdditionalInformationFormInput) => onSubmit(data))}>
                <div className="row">
                    <div className="col col-md-8">
                        <div className="card-main-title">
                            Additional Information
                        </div>                        
                    </div>
                    <div className="col col-md-3">
                    <FormControl.Select
                        control={control}
                        name="markAll"
                        label="Mark All"
                        options={complianceData}
                        style={controlInline}
                        required
                    />
                    </div>
                    <div className="col col-md-1" style={h1Styles}>
                    <Button name="markAll" className="btn btn-primary" onClick={markClick} >Apply</Button>
                    </div>
                </div>
                <Card.Container>

                <Card.Header>
                    <Card.Title>{props.title}</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Layout.Row>   <>
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="unobstructedAreaComplianceId"
                                    label="Unobstructed Area"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showUnobstructedAreaComment &&
                            showUnobstructedAreaComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="unobstructedAreaComment"
                                            defaultValue={''}
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="stormwaterRunoffComplianceId"
                                    label="Stormwater/Roof Runoff"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showStormwaterRunoffComment &&
                            showStormwaterRunoffComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="stormwaterRunoffComment"
                                            defaultValue={''}
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="alarmComplianceId"
                                    label="Alarms"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showAlarmComment &&
                            showAlarmComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="alarmComment"
                                            defaultValue={''}
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="supportDocumentComplianceId"
                                        label="Supporting Documentation"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showSupportDocumentComment &&
                            showSupportDocumentComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="supportDocumentnComment"
                                            defaultValue={''}
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="buildingAreaComplianceId"
                                    label="Building Area"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showBuildingAreaComment &&
                            showBuildingAreaComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="buildingAreaComment"
                                            defaultValue={''}
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="sitePlanComplianceId"
                                    label="Compliance with Site Plan"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showSitePlanComment &&
                            showSitePlanComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="sitePlanComment"
                                            defaultValue={''}
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="finalSiteGradeComplianceId"
                                    label="Final Site Grading"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showFinalSiteGradeComment &&
                            showFinalSiteGradeComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="finalSiteGradeComment"
                                            defaultValue={''}
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="contractorComplianceId"
                                    label="Contractor"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div  className="col col-md-8">
                            {/* <FormControl.Select
                                    control={control}
                                    name="contractorId"
                                    label="Contractor or Business Name"
                                    options={complianceData}
                                    required
                                /> */}
                            <Controller
                                control={control}
                                name="ehdcontactId" 
                                defaultValue={0}                             
                                render={({ field, fieldState}) => (
                                <Select2
                                    label="Contractor or Business Name"
                                    setValue={setValue}
                                    type="text"
                                    options={contractorData}
                                    md={4}
                                    {...field}
                                    state={fieldState}
                                    required= {showContractorComment != Constants.Not_Applicable && showContractorComment !=Constants.Unobserved }
                                        />
                                 )}
                                 />
                            </div>
                        </div>
                        {showContractorComment &&
                            showContractorComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="contractorComment"
                                            defaultValue={''}
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        
                        
                            <div className="row">
                           
                            <div className="col col-md-4" hidden>
                                <FormControl.Text
                                    control={control}
                                    name="inspectionStatusId"
                                    label="Created By"
                                    required
                                />
                                  <FormControl.Hidden
                                    control={control}
                                    name="applicationInspectionId"
                                    required
                                />
                            </div>
                            

                        </div>

                        </>
                    </Layout.Row>
                </Card.Body>
                <Card.Footer>
                    <div className="d-flex">
                        <span className="btn btn-link" onClick={(e) => {
                            e.preventDefault();
                            setValue('inspectionStatusId', InspectionStatus.Incomplete);
                            submit()

                            }}><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"></path>
                                    <path d="M8 12l4 4"></path><path d="M8 12h8"></path>
                                    <path d="M12 8l-4 4"></path>
                                </svg> Save and Exit
                            </span>
                        <div className="btn-list ms-auto">
                            <Link
                                to={props.returnPath}
                                className="btn btn-light"
                                role="button"
                            >
                                Cancel
                            </Link>
                            <Button className="btn btn-primary ms-auto" onClick={(e) => {
                                e.preventDefault();
                                setValue('inspectionStatusId', InspectionStatus.Complete);
                                submit()

                            }}>Next</Button>
                        </div>
                    </div>
                </Card.Footer>
                
            </Card.Container>
            </form>
        )

}